module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('a', {
    staticClass: "logo logo__left",
    attrs: {
      "href": "http://www.bactistatin.com/about/",
      "target": "_blank"
    },
    on: {
      "click": _vm.gaLogoClick
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/logo-b2.png",
      "alt": "baktistatin"
    }
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('a', {
    staticClass: "logo logo__right",
    attrs: {
      "href": "https://eda.ru/",
      "target": "_blank"
    },
    on: {
      "click": _vm.gaLogoClick
    }
  }, [_c('span', [_vm._v("спецпроект")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/images/icons/eda.png",
      "alt": "Eda Logo"
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo-text mobile-hidden"
  }, [_c('span', [_vm._v("БАКТИСТАТИН ® представитель нового поколения пробиотиков – метабиотик* ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a041b252"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/Header.vue
// module id = 104
// module chunks = 0